import { CorporatePortal } from "@capone-corporate/portal";
import "@capone-corporate/portal/style.css";

export default CorporatePortal;
